import React from 'react'
import { TableCell, useColorMode } from '@airbus/components-react/components'
import useMediaQuery from '@airbus/components-react/lib/hooks/useMediaQuery'
import { TableCellProps } from '@airbus/components-react/components/Table/Table'

const ResponsiveTableCell = (props: TableCellProps) => {
  const {
    size,
    responsive: { breakpoint },
  } = useColorMode()

  const mqMaxMD = useMediaQuery(`(max-width: ${breakpoint[props.breakpoint || 'lg']}px)`) // true si la largeur d'écran est inférieur à lg : 1200px

  // return <TableCell {...props} style={{ ...props.style, padding: mqMaxMD ? '0' : props.style.padding }} />
  //  overflowWrap: 'anywhere'
  return (
    <TableCell
      {...props}
      style={{
        padding: mqMaxMD ? `0 ${size.spacing[2]}` : `0 ${size.spacing[16]}`,
        overflowWrap: props.head ? 'normal' : 'anywhere',
        ...props.style,
      }}
    />
  )
}

export default ResponsiveTableCell
